module.exports = __webpack_public_path__ + "static/media/Construction-Villas-Vaud.6e670b16.jpg";